import React from "react";
import Header from "../components/Header";
import AnnouncementBanner from "../components/AnnouncementBanner";
import Hero from "../components/Hero";
import PromoBanner from "../components/PromoBanner";
import MenuSection from "../components/MenuSection";
import Chefs from "../components/Chefs";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import CateringSection from "../components/CateringSection";
import LoyaltySection from "../components/LoyaltySection";
import OrderSection from "../components/OrderSection";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import ShareSection from "../components/ShareSection";
import CartDrawer from "../components/CartDrawer";
import WhatsAppFab from "../components/WhatsAppFab";

const Home = () => (
    <div className="bg-earth-50">
        <AnnouncementBanner />
        <Header />
        <main>
            <Hero />
            <PromoBanner />
            <MenuSection />
            <Chefs />
            <Testimonials />
            <About />
            <CateringSection />
            <LoyaltySection />
            <OrderSection />
            <Contact />
            <ShareSection />
        </main>
        <Footer />
        <CartDrawer />
        <WhatsAppFab />
    </div>
);

export default Home;
